export default {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
};
